export default [
  { label: 'Razão social', field: 'razaoSocial', type: 'custom' },
  { label: 'CNPJ/CPF', field: 'cadastroFederal', tdClass: 'col-tamanho-cnpj' },
  { label: 'Nº Processo', field: 'identificacao', tdClass: 'col-tamanho-cnpj' },
  { label: 'Situação', field: 'situacao', type: 'custom' }, // regular ou irregular
  { label: 'Data vencimento', field: 'dataVencimento', type: 'custom' },
  {
    label: 'Última parcela lida', field: 'mesUltimaParcela', tdClass: 'alinhar-coluna', type: 'custom',
  },
  { label: 'Parcela', field: 'nmrUltimaParcelaDe', type: 'custom' },
  { label: 'Parcelas em atraso', field: 'parcelasEmAtraso', type: 'custom' },
  { label: 'Consultado em', field: 'ultimaExecucao' },
]
